module.exports = __webpack_public_path__ + "static/media/map_marker.573773d9.svg";